import axios from "../utilities/api-axios"

const apiUrl = process.env.REACT_APP_API_URL;

export class CountryService {
    async getCountries() {
        return await axios.get(`${apiUrl}/countries/`).then((res) => res.data);
    }
}
